var exports = {
  "DZ": "Heading__FF_S65",
  "az": "Box__YRQdAd",
  "wy": "Box_1__IMXVol",
  "Hh": "ActionMenu_Button__bNoxCP",
};

module.exports = exports;
